import context, { getDefaultState } from 'chimera/all/store/context'
import deepmerge from 'deepmerge'

export const state = () => {
  return deepmerge(getDefaultState(), {
    country: 'it',
    language: 'it',
  })
}

export default {
  ...context,
  state,
}
